'use client';

import { ApiKeys, fetcher } from '@insta-club/api';
import { useSessionStore } from '@insta-club/state';
import { usePathname } from 'next/navigation';
import { createContext, useContext, useEffect, useRef } from 'react';

interface DailyVisitContextType {
    recordVisit: () => Promise<void>;
}

const DailyVisitContext = createContext<DailyVisitContextType | undefined>(undefined);

export function DailyVisitProvider({ children }: { children: React.ReactNode }) {
    const hasRecorded = useRef(false);
    const pathname = usePathname();
    const authStatus = useSessionStore((state) => state.status);

    const getTodayKey = () => {
        const today = new Date();
        return `last-visit-${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;
    };

    // const shouldRecordVisit = () => {
    //     const todayKey = getTodayKey();
    //     const lastVisit = localStorage.getItem('daily-visit-key');

    //     return lastVisit !== todayKey;
    // };

    const recordVisit = async () => {
        if (hasRecorded.current) return;

        // if (!shouldRecordVisit()) {
        //     //   console.log('حضور امروز قبلاً ثبت شده است');
        //     return;
        // }

        if (authStatus !== 'authenticated') {
            // not authenticated
            return;
        }

        try {
            hasRecorded.current = true;

            const response = await fetcher(ApiKeys.POST_LAST_VISIT, 'dashboard', 'POST', {
                body: {
                    location: pathname,
                    timestamp: new Date().toISOString()
                }
            });

            if (response.ok) {
                const todayKey = getTodayKey();
                localStorage.setItem('daily-visit-key', todayKey);
                hasRecorded.current = false;
                // console.log('حضور امروز با موفقیت ثبت شد');
            } else {
                hasRecorded.current = false;
                // console.error('خطا در ثبت حضور');
            }
        } catch (error) {
            hasRecorded.current = false;
            console.error('خطا در ارسال درخواست:', error);
        }
    };

    useEffect(() => {
        recordVisit();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname, authStatus]);

    return <DailyVisitContext.Provider value={{ recordVisit }}>{children}</DailyVisitContext.Provider>;
}

export function useDailyVisit() {
    const context = useContext(DailyVisitContext);
    if (context === undefined) {
        throw new Error('useDailyVisit must be used within a DailyVisitProvider');
    }
    return context;
}

